"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
exports.createDefaultCache = function () {
    return new apollo_cache_inmemory_1.InMemoryCache({
        dataIdFromObject: function (o) {
            // tslint:disable-next-line triple-equals
            if (o.__typename != null && o.id != null) {
                return o.__typename + "-" + o.id;
            }
            return null;
        },
    });
};
//# sourceMappingURL=DefaultCache.js.map